import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles'
import GET_CATEGORIES from '../plugins/getCategories'
import { eventBlock } from '../plugins/event-block';

const [ w, d ] = [ window, document ]

class mainvisual {
  constructor () {
    this.slider_init('[data-plugin="slider"]');
    this.headline('topics', '.mainvisual', 'append');
  }

  slider_init(query) {
    $(query).slick({
      autoplay:true,
      fade: true,
      dots: true,
      speed: 300,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false
    })
  }

  headline (content, query, method) {
    $.when(
      this.getCategories({content}),
      this.getArticles({content, post_per_page: 1, category_in: 3})
    ).then( ([cats],[[item]]) => {
      item.category = item.category!='0'? cats.find(v => v.id == item.category): {name: 'その他'};
      render(item);
    });
    const render = data => {
      return $(query).length? $(query)[method](`
        <div class="mainvisual-headline">
          <h3 class="mainvisual-headline__title">EVENT</h3>
          <div class="mainvisual-headline__body">
            <span class="date">${date(data.date * 1000)}</span>
            <a href="${data.href}" class="title">${data.title}</a>
          </div>
        </div>
        <!-- /.mainvisual-headline -->
      `): false;
    }
    const date = unixtime => {
      let date = new Date(unixtime);
      let Y = String(date.getFullYear());
      let m = String(date.getMonth() + 1);
      let d = String(date.getDate());
      return `${Y}.${m.padStart(2,'0')}.${d.padStart(2,'0')}`;
    }
  }

  getCategories (option) {
    var opt = $.extend(true,{
          content: false
        },option)
    return $.getJSON('/asset/api/getCategories/',opt)
  }
  
  getArticles (option) {
    var opt = $.extend(true,{
          content: false,
          post_per_page: -1,
          post_status: 'publish',
          category_in: '',
          post_id: ''
        },option)
    return $.getJSON("/asset/api/getArticles/",opt)
  }
}


const init = () => {
  
  // slick実行
  // w.load['mainvisual'].then( () => new mainvisual );
  $( () => new mainvisual );
  
  // 画面固定ボタンをスクロール量で表示する
  $.when( w.load['header'] ).then( () => {
    $('.p-fixedNav').addClass('hidden')
    $.scrollspy({
      trigger: 200,
      onBefore () {
        $('.p-fixedNav').addClass('hidden')
      },
      onAfter () {
        $('.p-fixedNav').removeClass('hidden')
      }
    })
  });

  $.when( w.load['block-blog'] ).then( () => {
    let makeItem = (item,opt) => {
      return $(`
        <a href="${item.href}" class="${opt.content}-item">
          <figure class="${opt.content}-item__img">
            <img src="${item.thumb}" alt="${item.title}" width="100%" height="100%" loading="lazy">
          </figure>
          <div class="${opt.content}-item__body">
            <span class="date">${item.date}</span>
            <span class="cate">［<span>${item.category.name}</span>］</span>
            <h4 class="subject">${item.title.str_truncate(24,'…')}</h4>
          </div>
        </a>
      `)[0]
    }
    GET_ARTICLES('.block-blog__list[data-plugin="getArticles"]', { makeItem });
  });

  // $.when( w.load['block-event'] ).then( () => new eventBlock );
  w.addEventListener('load', () => new eventBlock );

  // works
  $.when( w.load['block-works'] ).then( () => {
    let makeItem = item => {
      let keywords = item.keywords? item.keywords.map(k => k.replace(/^(.+)$/,'<span class="tag">#$1</span>')): false
      return $(`
        <a href="${item.href}" class="case-item">
          <span class="cate">${item.category.name}</span>
          <figure class="case-item__img">
            <div class="case-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="100%" height="100%"></div>
          </figure>
          <div class="case-item__body">
            <h4 class="subject">${item.title}</h4>
            ${ keywords? `<div class="tags">${keywords.join('')}</div>`: ''}
          </div>
        </a>
      `)[0]
    }
    GET_ARTICLES('.block-works__list[data-plugin="getArticles"]', { makeItem })
  });

  // showroom
  $.when( w.load['block-showroom'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="block-showroom__item showroom-item">
        <div class="showroom-item__img"><img src="${item.thumb}" alt="${item.title}"></div>
        <div class="showroom-item__body">
          <span class="title">${item.title}</span>
          <span class="desc">${item.desc.replace(/\||｜/g,'<br />')}</span>
        </div>
        <!-- /.showroom-item__body -->
      </a>
      <!-- /.showroom-item__item showroom-item -->
    `)[0];
    GET_ARTICLES('.block-showroom__body[data-plugin="getArticles"]', { makeItem });
  });

  // news
  $.when( w.load['block-news'] ).then( () => {
    let makeItem = (item,opt) => {
      return $(`
        <a href="${item.href}" class="block-${opt.content}-item">
          <div class="block-${opt.content}-item__body">
            <span class="date">${item.date}</span>
            <span class="cate">［<span>${item.category.name}</span>］</span>
            <h4 class="subject">${item.title.str_truncate(100,'…')}</h4>
          </div>
        </a>
      `)[0]
    }
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem });
  })

}
export default function HOME() {
  w.addScript({src:'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js',defer:'true'});
  w.addStylesheet({href:'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css',media:'screen, projection, print'})
  $(() => init() );

}